export default function contains(root, n) {
  let node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }

  return false;
}



// WEBPACK FOOTER //
// ./_rc-util-4.5.0/src/Dom/contains.js